const files="static/"
   //const files=""

export default files;